import { useEffect, useState } from "react";

import { useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";

import { request } from "@/Api";
import { CustomBox } from "@/common/StyledComponents";

export default function BidCopyPopup({ bid, setBid }) {
    const theme = useTheme();
    const navigate = useNavigate();

    const bidName = bid ? `Copy of ${bid.name}` : "";
    const [customBidName, setCustomBidName] = useState(bidName);
    const [isCopying, setIsCopying] = useState(false);

    useEffect(() => {
        setCustomBidName(bidName);
    }, [bidName]);

    const copyBid = () => {
        setIsCopying(true);
        request
            .post("/bids/copy", {
                bid_name: customBidName,
                project_id: bid.project_id,
                bid_id: bid.id,
                is_change_order: bid.is_change_order,
            })
            .then((response) => {
                window.location = `/bids/${response.data.id}`;
                setBid(null);
                navigate(`/bids/${response.data.id}`, 0);
                setIsCopying(false);
            });
    };
    const handleInput = (event) => {
        setCustomBidName(event.target.value);
    };

    if (!bid) {
        return null;
    }

    return (
        <Modal
            sx={{ overflow: "scroll" }}
            open={bid != null}
            onClose={() => {
                setBid(null);
            }}
        >
            <CustomBox sx={{ background: theme.palette.background.default }}>
                <h1>Name your copy</h1>
                <TextField
                    fullWidth
                    value={customBidName}
                    onInput={handleInput}
                    sx={{ marginBottom: 3 }}
                />
                <div style={{ width: "100%", textAlign: "right" }}>
                    {isCopying ? (
                        <CircularProgress />
                    ) : (
                        <Button onClick={copyBid}>Copy!</Button>
                    )}
                </div>
            </CustomBox>
        </Modal>
    );
}
